<script>
import TemplatesPicker from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker.vue';
import TemplateParser from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplateParser.vue';

export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    modelValue: {
      type: [Array, Object],
      default: () => [],
    },
    inboxes: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    actionParams() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue[0] || {};
      }
      return this.modelValue || {};
    },
    selectedInboxId() {
      return this.actionParams.inbox_id;
    },
    selectedInbox: {
      get() {
        return (
          this.inboxes.find(
            inbox => Number(inbox.id) === Number(this.selectedInboxId)
          ) || null
        );
      },
      set(inbox) {
        this.selectedWaTemplate = null;
        this.updateActionParams(inbox ? { inbox_id: inbox.id } : {});
      },
    },
    storedTemplateParams() {
      return (
        this.actionParams.template_params ||
        this.actionParams.templateParams ||
        null
      );
    },
    templatesForInbox() {
      if (!this.selectedInboxId) return [];
      return this.$store.getters['inboxes/getWhatsAppTemplates'](
        this.selectedInboxId
      );
    },
    storedTemplate() {
      if (!this.storedTemplateParams) return null;

      return this.templatesForInbox.find(template => {
        const namespaceMatches =
          !this.storedTemplateParams.namespace ||
          template.namespace === this.storedTemplateParams.namespace;

        return (
          template.name === this.storedTemplateParams.name &&
          template.language === this.storedTemplateParams.language &&
          namespaceMatches
        );
      });
    },
    activeTemplate() {
      return this.selectedWaTemplate || this.storedTemplate;
    },
    templateParserKey() {
      if (!this.activeTemplate) return 'whatsapp-template-parser';

      return [
        this.selectedInboxId,
        this.activeTemplate.name,
        this.activeTemplate.language,
        this.activeTemplate.namespace,
      ].join(':');
    },
    initialProcessedParams() {
      return this.storedTemplateParams?.processed_params || {};
    },
  },
  methods: {
    updateActionParams(params) {
      this.$emit('update:modelValue', params);
    },
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
      this.updateActionParams({ inbox_id: this.selectedInboxId });
    },
    onUseTemplate({ message, templateParams }) {
      this.updateActionParams({
        inbox_id: this.selectedInboxId,
        message,
        template_params: templateParams,
      });
    },
  },
};
</script>

<template>
  <div class="whatsapp-template-action">
    <label class="template-label">
      {{ $t('AUTOMATION.ACTION.WHATSAPP_TEMPLATE_INBOX_LABEL') }}
    </label>
    <div class="multiselect-wrap--small">
      <multiselect
        v-model="selectedInbox"
        track-by="id"
        label="name"
        :placeholder="
          $t('AUTOMATION.ACTION.WHATSAPP_TEMPLATE_INBOX_PLACEHOLDER')
        "
        selected-label
        :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
        deselect-label=""
        :max-height="160"
        :options="inboxes"
        :allow-empty="false"
        :option-height="104"
      />
    </div>
    <div v-if="selectedInboxId" class="template-body">
      <TemplateParser
        v-if="activeTemplate"
        :key="templateParserKey"
        :template="activeTemplate"
        :initial-processed-params="initialProcessedParams"
        :submit-label="$t('AUTOMATION.ACTION.WHATSAPP_TEMPLATE_USE_BUTTON')"
        @reset-template="onResetTemplate"
        @send-message="onUseTemplate"
      />
      <TemplatesPicker
        v-else
        :inbox-id="selectedInboxId"
        @on-select="pickTemplate"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.whatsapp-template-action {
  @apply mt-2;
}

.template-label {
  @apply block text-xs font-medium mb-1;
}

.template-body {
  @apply mt-2;
}
</style>
